
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"24","height":"24","rx":"12","fill":"#FFCC18"}}),_c('path',{attrs:{"d":"M9.786 3.37a3.033 3.033 0 014.432 0c.598.64 1.443.99 2.318.96a3.033 3.033 0 013.134 3.135c-.03.875.32 1.72.96 2.318a3.033 3.033 0 010 4.432 3.034 3.034 0 00-.96 2.319 3.033 3.033 0 01-3.134 3.134c-.875-.03-1.72.32-2.318.96a3.033 3.033 0 01-4.432 0 3.033 3.033 0 00-2.319-.96 3.033 3.033 0 01-3.134-3.134c.03-.875-.32-1.72-.96-2.319a3.033 3.033 0 010-4.432c.64-.598.99-1.443.96-2.318A3.033 3.033 0 017.467 4.33c.875.03 1.72-.32 2.319-.96z","fill":"#FF6B00"}}),_c('path',{attrs:{"d":"M11.049 5.927c.3-.921 1.603-.921 1.902 0l.845 2.6a1 1 0 00.951.692h2.735c.969 0 1.371 1.24.588 1.809l-2.213 1.607a1 1 0 00-.363 1.118l.845 2.601c.3.921-.755 1.688-1.539 1.118l-2.212-1.607a1 1 0 00-1.176 0L9.2 17.472c-.784.57-1.838-.197-1.539-1.118l.845-2.6a1 1 0 00-.363-1.119L5.93 11.028c-.783-.57-.38-1.81.588-1.81h2.735a1 1 0 00.95-.69l.846-2.601z","fill":"#fff"}})])
          )
        }
      }
    